import { render, staticRenderFns } from "./MessageModalComponent.vue?vue&type=template&id=7a8ae348&scoped=true&"
import script from "./MessageModalComponent.vue?vue&type=script&lang=js&"
export * from "./MessageModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8ae348",
  null
  
)

export default component.exports